<template>
    <div id="app">
        <Heade>
            <template v-slot:back ><img src="../../assets/img/02-2左new.png" alt="" @click="$router.push(backUrl)"></template>
            <template v-slot:title>视频播放</template>
        </Heade>
        <div class="allpage" :style="{height: curHeight + 'px'}">
            <div class="video">
                <div class="prism-player" id="player-con" style="height:202px"></div>
                <div class="transmitNumber" v-show="isTransmitNumber">
                    <img src="../../assets/img/bofang.png" alt="">
                    <span>{{transmitNumber}}</span>
                </div>
            </div>
        </div>
        <div class="schedule" v-show="!isShow" id="sch">
            <img style="height:auto;" :src="schedule_url" alt="">
        </div>
    </div>
</template>
    <style>
        .video-dimensions {
            width: 100%;
        }
    </style>

    <script>
        export default {
            data(){
                return {
                    message: 3,
                    isShow: true,
                    id: '',//会议id
                    video_id: '',//视频ID
                    schedule_url: '',//日程表地址
                    video_cover_url: '',//视频封面
                    CommentList: [],//评论列表
                    num: 0,
                    arr: [],
                    isLoad: false,
                    transmitNumber: 0,//播放数量
                    isTransmitNumber: true,
                    curHeight: 0,
                    backUrl: ''
                }
            },
            beforeMount() {   
                this.$nextTick(function () {
                    let pageHeight = document.documentElement.clientHeight || document.body.clientHeight; 
                    let headerHeight = document.getElementsByClassName("header")[0].clientHeight;
                    this.curHeight = pageHeight - headerHeight; //减去页面上固定高度height  
                })
            },
            mounted() {
                this.id = this.$route.query.id;
                this.video_id = this.$route.query.video_id;
                this.backUrl = this.$route.query.path;
                this.view_num = this.$route.query.view_num;   
                this.transmitNumber = this.view_num > 9999 ? (this.view_num / 10000).toFixed(1) + '万' : this.view_num;             
                this.playVideo(this.video_id);
                this.getPath();
            },
            methods: {
                //播放视频。
                playVideo(videoId) {
                    const _this = this;
                    this.axios.post("/api/video/getAliyunVideoPlayAuth", { videoId: videoId }).then(res => {
                        let data = res.data
                        if (data.code === "00000") {
                            console.log(data.model.playAuth);
                            console.log(data.model.coverUrl);

                            var player = new Aliplayer({
                                "id": "player-con",
                                "vid": videoId,
                                "playauth": data.model.playAuth,
                                "cover": data.model.coverUrl,
                                "width": "100%",
                                "height": "433px",
                                "autoplay": false,
                                "isLive": false,
                                "rePlay": false,
                                "playsinline": true,
                                "preload": true,
                                "controlBarVisibility": "hover",
                                "useH5Prism": true
                            }, function (player) {
                                console.log("The player is created");
                                // player.play();
                                player.on('play', function (e) {
                                    console.log('播放开始')
                                    _this.isTransmitNumber = false;
                                });
                            }
                            );

                        } else {
                            alert("获取播放授权码错误，请返回重试。");
                        }
                    })
                },
                //获取视频地址图片地址
                getPath() {
                    var _this = this;
                    var params = {
                        id: this.id
                    }
                    const url = "/api/videoRecord/getVideoRecordInfo";
                    this.axios.post(url,params,
                    { transformRequest: function (params) {return JSON.stringify(params);},
                    headers: {'Content-Type': 'application/json;charset=UTF-8'}
                    }).then(res => {
                        console.log(res);
                        // if (res.data.code === "00000") {
                            _this.video_cover_url = res.data.model.video_cover_url;
                            _this.schedule_url = res.data.model.schedule_url;
                            const num = res.data.model.view_num;
                            //const num = 10800;
                            _this.transmitNumber = num > 9999 ? (num / 10000).toFixed(1) + '万' : num;
                            //_this.path = res.model.path;
                            _this.setVideo();
                        // }
                    });
                },
                checkJson(str) {
                    if (typeof str == 'string') {
                        try {
                            var obj=JSON.parse(str);
                            if(typeof obj == 'object' && obj ){
                                return true;
                            }else{
                                return false;
                            }

                        } catch(e) {
                            return false;
                        }
                    }
                },
                //返回
                goBack() {
                    this.$router.push('/RebroadcastList')
                },
                //配置video
                setVideo() {
                    var options = {
                        controls: 'control',
                        preload: 'none',
                        height: '422',
                    };
                    var player = videojs('video', options)

                    //待切换的视频源
                    var newVideo = this.path;
                    //console.log(newVideo,'666666')
                    //暂停视频
                    player.pause()
                    //获取视频节点（也就是video元素）
                    //值的注意的是，想通过id或者class获取该节点的时候，要注意video前后渲染的时候id和class改变了
                    //请使用渲染后的id或者class
                    //比如，这个原来的id是video，渲染后变成了video1_html5_api
                    var $video = $('video_html5_api')
                    $video.attr('src', newVideo)
                    //重载视频
                    player.load()
                    //开始视频
                    player.play()
                },
                //处理地址
                // getQueryString(name) {
                //     var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
                //     var r = window.location.search.substr(1).match(reg);
                //     if (r != null) return unescape(r[2]);
                //     return null;
                // }
            }
        }
    </script>
<style lang="less" scoped>
.allpage{
    width: 100%;
    background: black;
    display: flex;
    align-items: center;
}
.title{
    width: 100%;
    height: 82px;
    background: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 32px;
    position: relative;
    .back{
        position: absolute;
        top: 20px;
        left: 30px;
        img{
            width: 15px;
            height: 26px;
        }
    }
}
.video{
    width: 100%;
    height: 422px;
    // background: #ffffff;
    position: relative;
    .transmitNumber{
        position: absolute;
        top: 22px;
        right: 30px;
        font-size: 24px;
        color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 100;
        img{
            margin-right: 12px;
        }
    }
}
.myTab{
    width: 100%;
    height: 82px;
    display: flex;
    align-items: center;
    background: #ffffff;
    border-bottom: 1px solid #c7c8c9;
    div{
        font-size: 32px;
        font-weight: bold;
        color: #000;
        width: 50%;
        text-align: center;
        position: relative;
        span{
            position: absolute;
            bottom: -15px;
            left: 44%;
            display: inline-block;
            width: 50px;
            height: 9px;
            background: #007aff;
        }
    }
}
.content{
    width: 100%;
    overflow-y: auto;
    height: 500px;
    .person{
        box-sizing: border-box;
        padding: 30px;
        background: #ffffff;
        border-bottom: 1px solid #e5e5e5;
        .name{
            display: flex;
            align-items: center;
            .img{
                width: 75px;
                height: 75px;
                img{
                    width: 100%;
                    height: 100%;
                }
            }
            .txt{
                font-size: 26px;
                color: #666666;
                margin-left: 30px;
            }
        }
        .discuss{
            font-size: 28px;
            color: #000000;
            margin-top: 30px;
        }
        .date{
            font-size: 24px;
            margin-top: 28px;
            color: #999999;
        }
    }
    .more{
        font-size: 26px;
        width: 100%;
        height: 50px;
        color: #333;
        text-align: center;
        line-height: 50px;
    }
}
.schedule{
    width: 100%;
    box-sizing: border-box;
    padding: 30px;
    img{
        width: 100%;
        height: 100%;
    }
}
/deep/.prism-big-play-btn{
    left: 42%!important;
    bottom: 35%!important;
}
    </style>